import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Typography,
  Button,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Grid,
  Checkbox,
  Collapse,
  IconButton,
  Card,
  CardContent,
  Hidden,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CancelIcon from "@mui/icons-material/Cancel";
import SaveIcon from "@mui/icons-material/Save";
import { Dropdown } from "../../sharedComponents/formFields/FormFields";

const UserRoles = ({
  userRoles,
  userDetails,
  formattedUserRoles,
  leagues,
  handleAddRole,
  handleDeleteRow,
  handleRoleChange,
  onCancelAddEdit,
  handleSubmit,
}) => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleCollapse = () => setIsOpen(!isOpen);

  return (
    <Grid item lg={12} md={12} sm={12} xs={12} my={2}>
      <Card sx={{ backgroundColor: "#E6E6FA" }}>
        <CardContent>
          <Grid container alignItems="center" mb={1}>
            <Grid item lg={8} md={8} sm={6} xs={6}>
              <Typography variant="subtitle2" component="label">
                Roles{" "}
                <Button
                  size="small"
                  variant="outlined"
                  onClick={handleAddRole}
                  sx={{ mr: 2 }}
                >
                  + Add Role
                </Button>
              </Typography>
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={6}>
              <Grid
                container
                alignItems="center"
                justifyContent="flex-end"
                spacing={1}
              >
                <Grid item>
                  <Button
                    size="small"
                    variant="outlined"
                    color="error"
                    onClick={onCancelAddEdit}
                    startIcon={<CancelIcon />}
                  >
                    <Hidden smDown>Cancel</Hidden>
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    startIcon={<SaveIcon />}
                  >
                    <Hidden smDown>Save</Hidden>
                  </Button>
                </Grid>
                <Grid item>
                  <IconButton onClick={toggleCollapse}>
                    {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Collapse in={isOpen}>
            <Paper sx={{ mt: 2, overflowX: "auto" }}>
              <Table sx={{ tableLayout: "fixed", minWidth: 800 }}>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold", width: "250px" }}>
                      Role Name <span style={{ color: "red" }}>*</span>
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", width: "250px" }}>
                      League
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold", width: "200px" }}
                      align="center"
                    >
                      Active For Ballot Email
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold", width: "100px" }}
                      align="center"
                    >
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {userRoles.map((row, index) => (
                    <TableRow key={row.userRoleId || index}>
                      <TableCell sx={{ width: "250px" }}>
                        <Dropdown
                          name="roleId"
                          value={row.roleId}
                          handleChange={(e) =>
                            handleRoleChange(index, "roleId", e.target.value)
                          }
                          placeholder="Select user role"
                          options={formattedUserRoles}
                          disableOptionCondition={(option) => {
                            const userType =
                              userDetails?.userType?.toLowerCase();

                            const allowedIdsByType = {
                              admin: [1],
                              team: [3, 4, 5, 6],
                              league: [2, 3],
                            };

                            const allowedIds = allowedIdsByType[userType];

                            //@ If userType missing or invalid, enable all (disable none)
                            if (!allowedIds) return false;

                            //@ Disable option if id not in allowed list
                            return !allowedIds.includes(option?.id);
                          }}
                        />
                      </TableCell>

                      <TableCell sx={{ width: "250px" }}>
                        <Dropdown
                          name="leagueId"
                          value={row.leagueId}
                          handleChange={(e) =>
                            handleRoleChange(index, "leagueId", e.target.value)
                          }
                          placeholder="Select League"
                          options={leagues}
                          disabled={[1, 2].includes(row.roleId)}
                        />
                      </TableCell>

                      <TableCell sx={{ width: "200px" }} align="center">
                        <Checkbox
                          checked={row.activeForBallotEmail}
                          onChange={(e) =>
                            handleRoleChange(
                              index,
                              "activeForBallotEmail",
                              e.target.checked
                            )
                          }
                          disabled={[1, 2, 3].includes(row.roleId)}
                        />
                      </TableCell>

                      <TableCell sx={{ width: "100px" }} align="center">
                        <IconButton
                          color="error"
                          onClick={() => handleDeleteRow(row.userRoleId, index)}
                          size="small"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Paper>
          </Collapse>
        </CardContent>
      </Card>
    </Grid>
  );
};

UserRoles.propTypes = {
  userRoles: PropTypes.arrayOf(
    PropTypes.shape({
      //userRoleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      roleId: PropTypes.string.isRequired,
      // leagueName: PropTypes.string.isRequired,
      // activeForBallotEmail: PropTypes.bool.isRequired,
    })
  ).isRequired,
  formattedUserRoles: PropTypes.array.isRequired,
  leagues: PropTypes.array.isRequired,
  handleAddRole: PropTypes.func.isRequired,
  handleDeleteRow: PropTypes.func.isRequired,
  handleRoleChange: PropTypes.func.isRequired,
  onCancelAddEdit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default UserRoles;
